import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import { useCallback } from 'react';
import styles from './Radio.module.scss.js';

var Radio = React.memo(function (props) {
    var handleChange = useCallback(function (e) {
        web2clientSounds.playCheckboxSound();
        if (props.onChange)
            props.onChange(e);
    }, [props.onChange]);
    return (React.createElement("label", { className: classNames(styles.label, props.className) },
        React.createElement("input", { className: styles.input, type: "radio", name: props.name, value: props.value, checked: props.isChecked, disabled: props.isDisabled, onChange: handleChange }),
        React.createElement("span", { className: styles.radio }),
        React.createElement("div", { className: styles.caption }, props.children)));
});

export { Radio as default };
//# sourceMappingURL=Radio.js.map
